import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class CurrierCompanyService {
static currierCompanyCreate = async (values) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/currier-company/create",
        data: values,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static currierCompanyDetailsSearch = async (rowsPerPage, page, searchTerm) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/currier-company/search",
        data: {
          filter: [],
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let productDetail = response.data.data;
      return productDetail;
    } catch (err) {
      throw err;
    }
  };

  static currierCompanyDetailsID = async (companyID) => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/currier-company/" + companyID,
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let currierCompanyDetailID = response.data.data;

      return currierCompanyDetailID;
    } catch (err) {
      throw err;
    }
  };

  static currierCompanyDelete = async (companyID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/currier-company/" + companyID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static currierCompanyUpdate = async (companyID, bodydata) => {
    try {
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/currier-company/update/" + companyID,
        data: bodydata,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static currierCompanies = async () => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/currier-company/get/all",
        headers: {
            Authorization: `Bearer ${authToken}`,
          },
      });
      let companiesDetail = response.data.data;
      return companiesDetail;
    } catch (err) {
      throw err;
    }
  };

}
